<template>
	<div class="loading">
		<div class="lds-ring">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
</template>
<style scoped>


.lds-ring {
	display: inline-block;
	position: relative;
	width: 25px;
	height: 25px;
	bottom: 12.5px;
}

.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 50px;
	height: 50px;
	margin-top: 5px;
	margin-right: 10px;
	border: 2px solid var(--white);
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: var(--white) transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}

@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
.loading {
	margin-right: 30px;
	display: flex;
	/* padding-top: 20px; */
	/* margin-left: 40%; */
	height: 100%;
	margin-left: 0px;
	max-height: 100%;
	min-height: 300px;
	justify-content: center;
	/* text-align: center; */
	align-items: center;
	padding-top: 0px;
}

html[dir="rtl"] .loading {
	margin-left: 30px;
	/* margin-right: 45%; */
    margin-right: unset;
    /* margin-right: 45%; */
}

</style>